import React, { useState } from "react";
import Swal from "sweetalert2";
import { sendMessage } from "../services/api";
import { Link } from "react-router-dom";
import Chat from "../components/Chat";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    emailAddress: "",
    subject: "",
    phoneNumber: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await sendMessage(formData);
      if (response.success === true) {
        Swal.fire({
          icon: "success",
          title: "Message Sent!",
          text: "Your message has been sent successfully. We will be in touch soon!",
        }).then(() => {
          setFormData({
            name: "",
            emailAddress: "",
            subject: "",
            phoneNumber: "",
            message: "",
          });
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            response.message || "Something went wrong! Please try again later.",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error.response?.data?.message ||
          "Something went wrong! Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        .breadcumb-wrapper {
          background-size: cover;
          background-position: center;
          padding: 120px 0 80px;
        }
        .breadcumb-title {
          font-size: 2.5rem;
          font-weight: 700;
          color: #fff;
        }
        .breadcumb-menu {
          color: #e86b24;
        }
        .breadcumb-menu a {
          color: rgba(255,255,255,0.8);
          text-decoration: none;
        }

        /* Contact info cards */
        .contact-info-card {
          background: #fff;
          border-radius: 12px;
          padding: 30px 20px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.05);
          height: 100%;
          transition: transform 0.3s, box-shadow 0.3s;
        }
        .contact-info-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 30px rgba(0,0,0,0.1);
        }
        .contact-info-card .icon {
          font-size: 2rem;
          color: #e86b24;
          margin-bottom: 1rem;
        }
        .contact-info-card h5 {
          font-weight: 600;
          color: #0a1a3d;
          margin-bottom: 1rem;
        }
        .contact-info-card p, .contact-info-card a, .contact-info-card span {
          font-size: 0.95rem;
          color: #555;
          line-height: 1.6;
        }
        .contact-info-card a {
          color: #e86b24;
          text-decoration: none;
        }

        /* Form card */
        .form-card {
          background: #fff;
          border-radius: 16px;
          padding: 3rem 2rem;
          box-shadow: 0 10px 30px rgba(0,0,0,0.08);
          margin-top: 3rem;
        }
        .form-card h2 {
          font-size: 1.8rem;
          font-weight: 700;
          color: #0a1a3d;
          margin-bottom: 1.5rem;
          text-align: center;
        }
        .form-group {
          position: relative;
          margin-bottom: 1.5rem;
        }
        .form-group i {
          position: absolute;
          top: 50%;
          left: 15px;
          transform: translateY(-50%);
          color: #aaa;
          font-size: 1rem;
        }
        .form-control {
          width: 100%;
          padding: 14px 20px 14px 45px;
          border: 1px solid #e0e0e0;
          border-radius: 12px;
          font-size: 0.95rem;
          color: #333;
          background: #fafafa;
          transition: border-color 0.3s, box-shadow 0.3s;
        }
        .form-control:focus {
          border-color: #e86b24;
          box-shadow: 0 0 0 3px rgba(232,107,36,0.1);
          outline: none;
        }
        textarea.form-control {
          padding-left: 45px;
          min-height: 130px;
          resize: vertical;
        }
        .th-btn {
          background: linear-gradient(135deg, #e86b24, #d2551a);
          color: #fff;
          border: none;
          padding: 14px 32px;
          border-radius: 50px;
          font-weight: 600;
          transition: background 0.3s, transform 0.2s;
          width: 100%;
          font-size: 1rem;
        }
        .th-btn:hover {
          background: linear-gradient(135deg, #d2551a, #b8430e);
          transform: translateY(-2px);
        }
        .th-btn:disabled {
          opacity: 0.7;
          transform: none;
        }

        @media (max-width: 576px) {
          .form-card {
            padding: 2rem 1.5rem;
          }
        }
      `}</style>

      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/assets/img/main/m1.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Contact Us</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Contact Us</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="space-top space-bottom">
        <div className="container">
          {/* Section Heading */}
          <div className="text-center mb-5">
            <h2
              style={{ fontSize: "2.2rem", fontWeight: 700, color: "#0a1a3d" }}
            >
              Let’s Start Your Journey to Homeownership.
            </h2>
            <p
              className="mt-3"
              style={{
                maxWidth: "700px",
                margin: "0 auto",
                color: "#555",
                fontSize: "1rem",
                lineHeight: "1.7",
              }}
            >
              Whether you are ready to book an inspection, exploring flexible
              payment plans, or inquiring about our heavy engineering services,
              our team of experts is ready to assist you. Reach out today, and a
              dedicated consultant will get back to you promptly.
            </p>
          </div>

          {/* Contact Info Cards */}
          <div className="row g-4 justify-content-center">
            <div className="col-lg-4 col-md-6">
              <div className="contact-info-card text-center">
                <div className="icon">
                  <i className="fal fa-location-dot" />
                </div>
                <h5>Visit Our Sales Office</h5>
                <p>
                  CON Oil Mega Filling Station, Kado Estate FCT, Abuja, Nigeria
                  <br />
                  <small>
                    (Drop in for a consultation with our real estate advisors)
                  </small>
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="contact-info-card text-center">
                <div className="icon">
                  <i className="fal fa-phone" />
                </div>
                <h5>Call or Chat With Us</h5>
                <p>
                  Sales & Inquiries:
                  <br />
                  <Link to="tel:07055558942">07055558942</Link>
                </p>
                <p>
                  Email Support:
                  <br />
                  <Link to="mailto:sagamaconstruction125@gmail.com">
                    sagamaconstruction125@gmail.com
                  </Link>
                  <br />
                  <small className="text-success">
                    24/7 Virtual Support via Email
                  </small>
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="contact-info-card text-center">
                <div className="icon">
                  <i className="fal fa-clock" />
                </div>
                <h5>Hours of Operation</h5>
                <p>
                  Monday - Friday: 9:00 AM - 5:00 PM
                  <br />
                  Sunday: Closed
                </p>
                <p className="mt-3 text-muted" style={{ fontSize: "0.9rem" }}>
                  <em>
                    Virtual inspections and diaspora support are available
                    outside office hours by appointment.
                  </em>
                </p>
              </div>
            </div>
          </div>

          <Chat />

          {/* Contact Form */}
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="form-card" id="send-message-form">
                <h2>Send Us a Message</h2>
                <p className="text-center mb-4" style={{ color: "#666" }}>
                  Fill out the form below, and our team will respond within 24
                  hours.
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          id="name"
                          placeholder="Full Name*"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                        <i className="fal fa-user" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control"
                          name="emailAddress"
                          id="email"
                          placeholder="Email Address*"
                          value={formData.emailAddress}
                          onChange={handleChange}
                          required
                        />
                        <i className="fal fa-envelope" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="tel"
                          className="form-control"
                          name="phoneNumber"
                          id="number"
                          placeholder="Phone Number*"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                          required
                        />
                        <i className="fal fa-phone" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <select
                          name="subject"
                          id="subject"
                          className="form-control"
                          value={formData.subject}
                          onChange={handleChange}
                          required
                          style={{ paddingLeft: "45px" }}
                        >
                          <option value="" disabled hidden>
                            Select Subject*
                          </option>
                          <option value="Buy a Home">Buy a Home</option>
                          <option value="Commercial Property">
                            Commercial Property
                          </option>
                          <option value="Engineering Project">
                            Engineering Project
                          </option>
                          <option value="General Inquiry">
                            General Inquiry
                          </option>
                        </select>
                        <i className="fal fa-tag" />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <textarea
                          name="message"
                          id="message"
                          className="form-control"
                          placeholder="Your Message*"
                          value={formData.message}
                          onChange={handleChange}
                          required
                        />
                        <i className="fal fa-pen" style={{ top: "25px" }} />
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        type="submit"
                        className="th-btn"
                        disabled={loading}
                      >
                        {loading ? (
                          <i className="fas fa-spinner fa-spin ms-2" />
                        ) : (
                          <>
                            Send Message{" "}
                            <i className="fas fa-long-arrow-right ms-2" />
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                  <div></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Google Map */}
      <div className="contact-map">
        <iframe
          title="Sagama Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3939.851856451291!2d7.414215916385525!3d9.07725764741688!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e0b2bd3b1110f%3A0xcb5b354063e42b66!2sKado%20Conoil%20Station!5e0!3m2!1sen!2sng!4v1747888285607!5m2!1sen!2sng"
          allowFullScreen
          loading="lazy"
          style={{ border: "none", width: "100%", height: "400px" }}
        />
      </div>
    </>
  );
};

export default Contact;
